import React from "react";
import { UserIcon, MinusIcon, PlusIcon } from "../icons";

interface GuestCounterProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

const GuestCounter: React.FC<GuestCounterProps> = ({
  value,
  onChange,
  className = "",
}) => {
  const increment = () => {
    onChange(value + 1);
  };

  const decrement = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || 0;
    onChange(newValue);
  };

  return (
    <div className={`space-y-2 ${className}`}>
      <label htmlFor="numberOfGuests" className="form-label">
        Liczba gości <span className="text-error-500">*</span>
      </label>
      <div className="flex items-center space-x-4">
        <div className="relative flex-1">
          <input
            type="number"
            name="numberOfGuests"
            id="numberOfGuests"
            min="1"
            className={`form-input text-center pl-12 ${
              value > 0 ? "form-input-valid" : ""
            }`}
            placeholder="1"
            value={value || ""}
            onChange={handleInputChange}
            required
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-4 text-primary-500">
            <UserIcon />
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            type="button"
            onClick={decrement}
            className="w-10 h-10 flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors duration-200 border border-neutral-300"
          >
            <MinusIcon />
          </button>
          <button
            type="button"
            onClick={increment}
            className="w-10 h-10 flex items-center justify-center bg-primary-100 hover:bg-primary-200 rounded-lg transition-colors duration-200 border border-primary-300 text-primary-600"
          >
            <PlusIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestCounter;
